import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {FunctionBarSingleSelectEditControlComponent} from "./function-bar/controls/function-bar-single-select-edit-control.component";
import {OutletSingleSelectEditControlComponent} from "./outlet/controls/outlet-single-select-edit-control.component";
import {ScreenLayoutSingleSelectEditControlComponent} from "./screen-layout/controls/screen-layout-single-select-edit-control.component";
import {LocationSingleSelectEditControlComponent} from "./location/controls/location-single-select-edit-control.component";
import {TerminalSingleSelectEditControlComponent} from "./terminal/controls/terminal-single-select-edit-control.component";
import {LocationMultiSelectSearchControlComponent} from "./location/controls/location-multi-select-search-control.component";
import {TerminalMultiSelectSearchControlComponent} from "./terminal/controls/terminal-multi-select-search-control.component";
import {OutletMultiSelectSearchControlComponent} from "./outlet/controls/outlet-multi-select-search-control.component";
import {TerminalTypeSelectOptionsComponent} from "./terminal/controls/terminal-type-select-options.component";
import {OutletMultiSelectEditControlComponent} from "./outlet/controls/outlet-multi-select-edit-control.component";
import {CourseDefinitionSingleSelectEditControlComponent} from "./course-definition/controls/course-definition-single-select-edit-control.component";
import {TerminalMultiSelectEditControlComponent} from "./terminal/controls/terminal-multi-select-edit-control.component";
import {CourseSingleSelectEditControlComponent} from "./course/controls/course-single-select-edit-control.component";
import {SiteSingleSelectEditControlComponent} from "./site/controls/site-single-select-edit-control.component";
import {CourseSingleSelectColumnComponent} from "./course/controls/course-single-select-column.component";
import {TableServiceAreaMultiSelectEditControlComponent} from "./table-service-area/controls/table-service-area-multi-select-edit-control.component";
import {
    IntegrationPartnerSingleSelectEditControlComponent
} from "./integration-partner/controls/integration-partner-single-select-edit-control.component";
import {
    WebTerminalMultiSelectEditControlComponent
} from "./web-terminal/controls/web-terminal-multi-select-edit-control.component";
import {
    WebTerminalMultiSelectSearchControlComponent
} from "./web-terminal/controls/web-terminal-multi-select-search-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        FunctionBarSingleSelectEditControlComponent,
        CourseDefinitionSingleSelectEditControlComponent,
        CourseSingleSelectColumnComponent,
        CourseSingleSelectEditControlComponent,
        OutletSingleSelectEditControlComponent,
        OutletMultiSelectEditControlComponent,
        OutletMultiSelectSearchControlComponent,
        ScreenLayoutSingleSelectEditControlComponent,
        LocationSingleSelectEditControlComponent,
        TerminalSingleSelectEditControlComponent,
        TerminalMultiSelectEditControlComponent,
        LocationMultiSelectSearchControlComponent,
        TerminalMultiSelectSearchControlComponent,
        OutletMultiSelectSearchControlComponent,
        TerminalTypeSelectOptionsComponent,
        IntegrationPartnerSingleSelectEditControlComponent,
        SiteSingleSelectEditControlComponent,
        TableServiceAreaMultiSelectEditControlComponent,
        WebTerminalMultiSelectEditControlComponent,
        WebTerminalMultiSelectSearchControlComponent
    ],
    exports: [
        FunctionBarSingleSelectEditControlComponent,
        CourseDefinitionSingleSelectEditControlComponent,
        CourseSingleSelectColumnComponent,
        CourseSingleSelectEditControlComponent,
        OutletSingleSelectEditControlComponent,
        OutletMultiSelectEditControlComponent,
        OutletMultiSelectSearchControlComponent,
        ScreenLayoutSingleSelectEditControlComponent,
        LocationSingleSelectEditControlComponent,
        TerminalSingleSelectEditControlComponent,
        TerminalMultiSelectEditControlComponent,
        LocationMultiSelectSearchControlComponent,
        TerminalMultiSelectSearchControlComponent,
        OutletMultiSelectSearchControlComponent,
        TerminalTypeSelectOptionsComponent,
        IntegrationPartnerSingleSelectEditControlComponent,
        SiteSingleSelectEditControlComponent,
        TableServiceAreaMultiSelectEditControlComponent,
        WebTerminalMultiSelectEditControlComponent,
        WebTerminalMultiSelectSearchControlComponent
    ]
})
export class PosSharedModule {
}
